import axios from 'axios';
import { config } from '../config';

const openaiService = {
    async getTripRecommendations(tripData) {
        try {
            const response = await axios.post(
                'https://api.openai.com/v1/chat/completions',
                {
                    model: "gpt-3.5-turbo",
                    messages: [
                        {
                            role: "system",
                            content: "You are a helpful travel assistant that provides concise, practical recommendations for flights and hotels."
                        },
                        {
                            role: "user",
                            content: `Please provide flight and hotel recommendations for a trip with the following details:
                                - From: ${tripData.flyingFrom}
                                - To: ${tripData.flyingTo}
                                - Dates: ${tripData.fromDate} to ${tripData.toDate}
                                - Number of travelers: ${tripData.travelers}
                                - Budget: $${tripData.budget}
                                
                                Format the response in two parts:
                                1. Flight recommendation (include airline, estimated price, and any layovers)
                                2. Hotel recommendation (include hotel name, location, and estimated price per night)`
                        }
                    ]
                },
                {
                    headers: {
                        'Authorization': `Bearer ${config.OPENAI_API_KEY}`,
                        'Content-Type': 'application/json'
                    }
                }
            );

            const recommendation = response.data.choices[0].message.content;
            const [flightRec, hotelRec] = recommendation.split('\n\n');

            return {
                flights: flightRec.replace('1. ', ''),
                hotel: hotelRec.replace('2. ', '')
            };
        } catch (error) {
            console.error('Error getting trip recommendations:', error);
            throw error;
        }
    }
};

export default openaiService;
